import enLocale from 'element-ui/lib/locale/lang/en'
import enJson from './en.json'

const en = {
    ...enLocale,
    ...enJson
}
export default en


// WEBPACK FOOTER //
// ./src/i18n/langs/en/index.js